<template>
  <div class="entry-popup-main" :style="{ zIndex: show ? 999 : -999, opacity: show ? 1 : 0 }">
    <div class="content">
      <div class="header">
        <div class="title">{{ title }}</div>
        <div class="dates">
          <Input v-if="createdBy" class="dates-input" placeholder="Created by" isDisabled="true" :inputValue="createdBy" />
          <Input v-if="updatedBy" class="dates-input" placeholder="Updated by" isDisabled="true" :inputValue="updatedBy" />
        </div>
      </div>
      <div class="body">
        <div v-if="!newStyle" :style="{ display: 'flex' }">
          <div v-for="(c, ci) in content" :key="ci" :style="{ width: `${100 / content.length}%`, padding: '0 5px' }">
            <div v-for="(el, ei) in c" :key="ei" :style="{ height: el.type == 'Tabs' ? '100%' : 'unset' }">
              <Input v-if="el.type == 'Input'" :placeholder="el.placeholder" :textAlign="el.textAlign" :textType="el.textType"
                    :inputValue.sync="el.inputValue" :isDisabled="el.isDisabled" :isRequired="el.isRequired" :ref="el.name"
                    :fileType="el.fileType" :multiFile="el.multiFile" :selectedFiles.sync="el.selectedFiles" @fileChanged="inputFileChanged"
                    @focusIn="elementFocus" :imgSelected.sync="el.imgSelected" :imgHeight="el.imgHeight" :imgWidth="el.imgWidth"
                    :imgType.sync="el.imgType" :hasDecimal="el.hasDecimal" />
              <InputQuery v-else-if="el.type == 'InputQuery'" :items="el.items" :placeholder="el.placeholder" :descKey="el.descKey"
                          :itemKey="el.itemKey" :selectedObject.sync="el.selectedObject" :isDisabled="el.isDisabled" :search.sync="el.search"
                          @focusIn="elementFocus" :isRequired="el.isRequired" :ref="el.name" />
              <Dropdown v-else-if="el.type == 'Dropdown'" :items="el.items" :itemKey="el.itemKey" :placeholder="el.placeholder" :isRequired="el.isRequired"
                        :textAlign="el.textAlign" :selectedItem="el.selectedItem" :selectedObject="el.selectedObject" :isDisabled="el.isDisabled" />
              <Tabs v-else-if="el.type == 'Tabs'" :tabsItems="el.tabsItems" @tabButtonclick="tButtonClick" @dropdownSelected="tDropdownSelected"
                    @checkboxChecked="tCheckboxChecked" @mapDrag="tMapDrag" @mapDragend="tMapDragend" @mapDragstart="tMapDragstart" @tabulatorRowSelected="tTabulatorRowSelected"
                    @tabulatorRowDblClick="tTabulatorRowDblClick" @tabulatorCellButtonClick="tTabulatorCellButtonClick" />
              <button v-else-if="el.type == 'button'" @click="buttonClick(el.value)">{{ el.value }}</button>
              <img v-else-if="el.type == 'img'" :src="el.src" :width="el.width" :height="el.height">
              <div style="font-size: 12px" v-else-if="el.type == 'html'" v-html="el.html"></div>
            </div>
          </div>
        </div>
        <div style="width: 100%" v-else-if="isComponent">
          <FreightPopup v-if="content.type == 'FreightPopup'" :data="content.popupData" />
          <SupplierPopup v-if="content.type == 'SupplierPopup'" :data="content.popupData" :tabs.sync="content.tabsData" />
          <PortPopup v-if="content.type == 'PortPopup'" :data="content.popupData" />
          <DeliveryNotesPopup v-if="content.type == 'DeliveryNotesPopup'" :data="content.popupData" />
          <DeliveryNotesJobs v-if="content.type == 'DeliveryNotesJobs'" :data="content.popupData"/>
          <ROTJobsPopup v-if="content.type == 'ROTJobsPopup'" :data="content.popupData"/>
          <ROTNewPopup v-if="content.type == 'ROTNewPopup'" :data="content.popupData"/>
          <CustomerPopUp v-if="content.type == 'CustomerPopUp'" :data="content.popupData"/>
          <VehiclePopup v-if="content.type == 'VehiclePopup'" :data="content.popupData" :tabs.sync="content.tabsData" />
          <PortBooking v-if="content.type == 'PortBooking'" :data="content.popupData"/>
          <PortBookingv2 v-if="content.type == 'PortBookingv2'" :data="content.popupData"/>
          <DocAppPopup v-if="content.type == 'DocAppPopup'" :data="content.popupData" />
        </div>
        <slot v-else-if="useSlot"></slot>
        <div style="width: 100%" v-else>
          <div v-for="(c, ci) in content" :key="ci" :style="{ display: Array.isArray(c) ? 'flex' : 'unset', alignItems: Array.isArray(c) ? 'center' : 'unset' }">
            <div class="tab-details" v-for="(el, ei) in Array.isArray(c) ? c : [c]" :key="ei" :style="{ width: Array.isArray(c) ? (el.width ? el.width : `calc(100% / ${c.length})`) : '100%', margin: Array.isArray(c) ? '0 2px' : 'unset' }">
              <Input v-if="el.type == 'Input'" :placeholder="el.placeholder" :textAlign="el.textAlign" :textType="el.textType"
                :inputValue.sync="el.inputValue" :isDisabled="el.isDisabled || viewMode" :isRequired="el.isRequired" :ref="el.name"
                :fileType="el.fileType" :multiFile="el.multiFile" :selectedFiles.sync="el.selectedFiles" @fileChanged="inputFileChanged"
                @focusIn="elementFocus" :imgSelected.sync="el.imgSelected" :imgHeight="el.imgHeight" :imgWidth="el.imgWidth"
                :imgType.sync="el.imgType" :hasDecimal="el.hasDecimal" :style="{ margin: el.margin, padding: el.padding }" />
              <InputQuery v-else-if="el.type == 'InputQuery'" :items="el.items" :placeholder="el.placeholder" :descKey="el.descKey"
                :itemKey="el.itemKey" :selectedObject.sync="el.selectedObject" :isDisabled="el.isDisabled" :search.sync="el.search"
                @focusIn="elementFocus" :isRequired="el.isRequired" :ref="el.name"
                :style="{ margin: el.margin, padding: el.padding }" />
              <Dropdown v-else-if="el.type == 'Dropdown'" :items="el.items" :itemKey="el.itemKey" :placeholder="el.placeholder" :isRequired="el.isRequired"
                :textAlign="el.textAlign" :selectedItem="el.selectedItem" :selectedObject="el.selectedObject" :isDisabled="el.isDisabled"
                :style="{ margin: el.margin, padding: el.padding }" />
              <Tabs v-else-if="el.type == 'Tabs'" :tabsItems="el.tabsItems" @tabButtonclick="tButtonClick" @dropdownSelected="tDropdownSelected"
                @checkboxChecked="tCheckboxChecked" @mapDrag="tMapDrag" @mapDragend="tMapDragend" @mapDragstart="tMapDragstart" @tabulatorRowSelected="tTabulatorRowSelected"
                @tabulatorRowDblClick="tTabulatorRowDblClick" @tabulatorCellButtonClick="tTabulatorCellButtonClick"
                :style="{ margin: el.margin, padding: el.padding }" />
              <TabView v-else-if="el.type == 'TabView'" :tabs="el.tabs" :activeTab.sync="el.activeTab" :style="{ margin: el.margin ? el.margin : '10px 0 0 0', padding: el.padding }"
                :viewMode="viewMode" @tabChanged="tabChanged" :loadingPage.sync="el.loadingPage" />
              <CheckBox v-else-if="el.type == 'CheckBox'" :title="el.title" :isChecked.sync="el.isChecked" :checkBackground="el.checkBackground"
                :checkColor="el.checkColor" :isDisabled="viewMode"
                :style="{ margin: el.margin, padding: el.padding }" />
              <button v-else-if="el.type == 'button'" @click="buttonClick(el.value)"
                :style="{ margin: el.margin, padding: el.padding }">{{ el.value }}</button>
              <img v-else-if="el.type == 'img'" :src="el.src" :width="el.width" :height="el.height" :style="{ margin: el.margin, padding: el.padding }">
              <div style="font-size: 12px" v-else-if="el.type == 'html'" v-html="el.html"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="message-box" :style="{ backgroundColor: getBackground() }">
          <div v-for="(s, i) in pSuccessMessages" :key="i">{{ s }}</div>
          <div v-for="(m, i) in pMessages" :key="i">{{ m }}</div>
          <div v-for="(e, i) in pErrorMessages" :key="i">{{ e }}</div>
          <div v-for="(r, i) in pRequiredError" :key="i">
            <a @click="requiredClick(r.Key)">{{ r.Value }}</a>
          </div>
        </div>
        <button v-if="!viewMode && !disabledSave" @click="saveClick()">
          <img src="https://img.icons8.com/officel/16/000000/checked.png">
          Save
        </button>
        <button @click="cancelClick()">
          <img src="https://img.icons8.com/ultraviolet/40/000000/cancel.png">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';
import InputQuery from '@/components/InputQuery.vue';
import Dropdown from '@/components/Dropdown.vue';
import Tabs from '@/components/Tabs.vue';
import TabView from '@/components/TabView.vue';
import CheckBox from '@/components/CheckBox.vue';

import FreightPopup from '@/components/popupComponents/FreightPopup.vue';
import SupplierPopup from '@/components/popupComponents/SupplierPopup.vue';
import PortPopup from '@/components/popupComponents/PortPopup.vue';
import DeliveryNotesPopup from '@/components/popupComponents/DeliveryNotes/DeliveryNotesPopup.vue';
import DeliveryNotesJobs from '@/components/popupComponents/DeliveryNotes/DeliveryNotesJobs.vue';
import ROTJobsPopup from '@/components/popupComponents/ROT/ROTJobsPopup.vue';
import ROTNewPopup from '@/components/popupComponents/ROT/ROTNewPopup.vue';
import CustomerPopUp from '@/components/popupComponents/CustomerProfileV2/CustomerPopUp.vue';

import VehiclePopup from '@/components/popupComponents/VehiclePopup.vue';

import PortBooking from '@/components/popupComponents/VehicleSchedule/PortBooking.vue';
import PortBookingv2 from '@/components/popupComponents/VehicleSchedule/PortBookingv2.vue';

import DocAppPopup from '@/components/popupComponents/DocAppPopup.vue';

export default { // OBSOLETE COMPONENT (Use PopupEntry.vue instead)
  components: {
    Input, InputQuery, Dropdown, Tabs, TabView, CheckBox,
    FreightPopup, SupplierPopup, PortPopup, DeliveryNotesPopup, DeliveryNotesJobs, ROTJobsPopup, ROTNewPopup,
    CustomerPopUp,
    VehiclePopup,
    PortBooking, PortBookingv2,
    DocAppPopup
  },
  data: function() {
    return {

    }
  },
  data: function() {
    return {
      pRequiredError: [],
      pSuccessMessages: [],
      pMessages: [],
      pErrorMessages: []
    }
  },
  props: {
    requiredError: { type: Array, default: function () { return [] } },
    successMessages: { type: Array, default: function () { return [] } },
    messages: { type: Array, default: function () { return [] } },
    errorMessages: { type: Array, default: function () { return [] } },
    focusableElement: { type: Array, default: function () { return [] } },
    currentFocusIndex: { type: Number, default: 0 },

    // Public properties
    content: { type: Object, default: function () { return null } }, // The content of the popup
    saveController: { type: String, default: '' }, // The controller where the data will be send to (Deprecated)
    title: { type: String, default: 'Entry Popup' }, // The title of the popup
    show: { type: Boolean, default: false }, // Set this to true to show the entry popup. Always use .sync for 2 way binding to ensure that the state of the popup is updated both component and parent
    disabledSave: { type: Boolean, default: false }, // Set this to true so that the entry popup is readOnly
    createdBy: { type: String, default: '' }, // The title of the popup
    updatedBy: { type: String, default: '' }, // The title of the popup
    newStyle: { type: Boolean, default: false },
    viewMode: { type: Boolean, default: false },
    isComponent: { type: Boolean, default: false },
    checkBeforeClose: { type: Boolean, default: false }, // Set to true if there is a checking before the entry popup is closed
    useSlot: { type: Boolean, default: false }, // 

    /* content properties template (OLD STYLE)
    [
      [ // This array is the first column
        { type: 'Input', name: 'myInput', other properties for the type }
      ],
      [ // This array is the second column
        { type: 'Input', name: 'myInput', other properties for the type }
      ],
      // .... Can have more arrays to have more columns
    ]
    */

    /* content properties template (NEW STYLE)
    [
      { type: 'Input' }, // This will be in line 1
      { type: 'Input' }, // This will be in line 2
      [ // The items in this array will be in line 3 (single line/inline)
        { type: 'Input' },
        { type: 'Input' },
        { type: 'Input' },
        { type: 'Input' },
        { type: 'Input' },
      ],
      ........
    ]
    */

    // Public event
    // @buttonClick - fired when a button in the content is clicked and returns the value of the button
    // @inputFile - return 2 variables, first is the array of files selected, second is the placeholder of the input
    // @saved - fired when save button is clicked
    // @cancelClick - fired when the cancel button is clicked

    // Public method
    // focusElement(name) - used to focus on an element by the specific name (Only applicable if the element is Input, InputQuery or Dropdown)
    // rendered - fired when the items are rendered and the EntryPopup is shown

    /*
    How to use Content properties
    - Currently can be use for 4 different types
      1.  Input
      2.  InputQuery
      3.  Dropdown
      4.  button
    - For Input, InputQuery and Dropdown, the properties are exactly the same as the custom components
    - For button, the properties only consists of value
    - For img, the properties consists of the src, height and width
    - Mandatory properties
      - type - Input/InputQuery/Dropdown/button/img/html (html is still beta)
      - name - The name of the component, needs to match the name in the model in order to do the required checking (currently only for input, inputquery and dropdown)
    */
  },
  methods: {
    saveClick: async function () {
      this.$emit('saved');
    },
    cancelClick: function () {
      this.pSuccessMessages = [];
      this.pMessages = [];
      this.pRequiredError = [];
      this.pErrorMessages = [];

      if (!this.checkBeforeClose) {
        this.show = false;
        this.$emit('update:show', this.show);
      }
      this.$emit('update:successMessages', this.pSuccessMessages);
      this.$emit('update:messages', this.pMessages);
      this.$emit('update:errorMessages', this.pErrorMessages);
      this.$emit('cancelClick');
    },
    requiredClick: function (error) {
      // this.$refs[error][0].setFocus();
      this.$emit('requiredClicked', error);
    },
    getBackground: function () {
      if (this.pErrorMessages.length > 0 || this.pRequiredError.length > 0) {
        return 'rgba(255, 121, 121, 0.37)';
      } else if (this.pSuccessMessages.length > 0) {
        return 'rgba(126, 255, 121, 0.37)';
      } else if (this.pMessages.length > 0) {
        return 'rgba(255, 246, 121, 0.37)';
      }
    },
    buttonClick: function (name) {
      this.$emit('buttonClick', name)
    },
    inputFileChanged: function (e, placeholder) {
      this.$emit('inputFile', e, placeholder);
    },
    focusElement: function (name) {
      this.$refs[name][0].setFocus();
    },
    keyDownEvent: function (e) {
      if (e.key == 'Tab') {
        if (e.shiftKey) {
          this.currentFocusIndex--;
        } else {
          this.currentFocusIndex++;
        }

        if (this.currentFocusIndex == this.focusableElement.length) {
          this.currentFocusIndex = 0;
        } else if (this.currentFocusIndex < 0) {
          this.currentFocusIndex = this.focusableElement.length - 1;
        }

        setTimeout(() => {
          this.$refs[this.focusableElement[this.currentFocusIndex]][0].setFocus();
        }, 10);
      } else if (e.key == 'Escape') {
        this.cancelClick();
      } else if (e.ctrlKey && e.key == 'Enter') {
        this.saveClick();
      }
    },
    elementFocus: function (e) {
      var elementName;

      this.content.forEach((c) => {
        c.forEach((el) => {
          if (el.placeholder == e.placeholder) {
            elementName = el.name;
          }
        });
      });

      this.currentFocusIndex = this.focusableElement.indexOf(elementName);
    },
    // Tabs events
    tButtonClick: function (e) {
      this.$emit('tabButtonclick', e);
    },
    tDropdownSelected: function (i, o, m) {
      this.$emit('dropdownSelected', i, o, m);
    },
    tCheckboxChecked: function (e, m) {
      this.$emit('checkboxChecked', e, m);
    },
    tMapDrag: function (e) {
      this.$emit('mapDrag', e);
    },
    tMapDragend: function (e) {
      this.$emit('mapDragend', e);
    },
    tMapDragstart: function (e) {
      this.$emit('mapDragstart', e);
    },
    tTabulatorRowSelected: function (e) {
      this.$emit('tabulatorRowSelected', e);
    },
    tTabulatorRowDblClick: function (e) {
      this.$emit('tabulatorRowDblClick', e);
    },
    tTabulatorCellButtonClick: function (e) {
      this.$emit('tabulatorCellButtonClick', e);
    },
    tabChanged: function(e) {
      this.$emit('tabChanged', e);
    }
  },
  watch: {
    requiredError: function (val) {
      this.pRequiredError = val;
      val.forEach((v) => {
        if (this.$refs[v.Key]) {
          this.$refs[v.Key][0].errorMessage = v.Value;
        }
      })
    },
    successMessages: function(val) {
      this.pSuccessMessages = val;
    },
    messages: function(val) {
      this.pMessages = val;
    },
    errorMessages: function(val) {
      this.pErrorMessages = val;
    },
    show: function (val) {
      if (val) {
        document.addEventListener('keydown', this.keyDownEvent);
      } else {
        document.removeEventListener('keydown', this.keyDownEvent);
      }
    },
    content: function (val) {
      this.focusableElement = [];
      if (val.length > 0) {
        val.forEach((v) => {
          v.forEach((el) => {
            if (el.type == 'Input' || el.type == 'InputQuery' || el.type == 'Dropdown' || el.type == 'button') {
              if (el.name) {
                this.focusableElement.push(el.name);
              }
            }
          });
        });

        setTimeout(() => {
          this.$refs[this.focusableElement[0]][0].setFocus();
        }, 50);
      }

      this.$nextTick(function () {
        this.$emit('rendered');
      });
    }
  },
  mounted() {
    if (this.requiredError) {
      this.pRequiredError = this.requiredError;
    }
    
    if (this.successMessages) {
      this.pSuccessMessages = this.successMessages;
    }

    if (this.messages) {
      this.pMessages = this.messages;
    }

    if (this.errorMessages) {
      this.pErrorMessages = this.errorMessages;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.entry-popup-main {
  height: calc(100% - #{$top-nav-height});
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: $top-nav-height;
  left: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 42px;
}

.entry-popup-main .content {
  height: 95%;
  width: 100%;
  background-color: white;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
}

.content > * {
  padding: 5px;
}

.content .header {
  display: flex;
  align-items: center;
  border-bottom: 2px solid rgb(180,180,180);
  
  .title {
    flex-grow: 1;
    margin-left: 10px;
    font-weight: bolder;
  }

  .dates {
    display: flex;

    .dates-input {
      margin: 0 3px;
    }
  }
}

.content .body {
  display: flex;
  flex-grow: 1;
  overflow-x: auto;

  > * {
    flex-grow: 1;
  }
}

.body {
  overflow-y: auto;
}

.content .footer {
  border-top: 2px solid rgb(180,180,180);
  display: flex;
  align-items: center;

  .message-box {
    flex-grow: 1;
    margin-right: 10px;
    background-color: rgba(255, 246, 121, 0.37);
    overflow: auto;
    height: 90px;
    max-height: 90px;
    padding-left: 5px;

    a {
      text-decoration: underline;
      cursor: pointer;
    }
  }

  button {
    padding: 5px;
    margin: 10px 3px;

    img {
      height: 25px;
    }
  }
}
</style>